import { z } from 'zod'

/**
 * Job cost categories enum
 */
export const JobCostCategory = z.enum(['labor', 'parts', 'equipment'])
export type JobCostCategory = z.infer<typeof JobCostCategory>

/**
 * Type guard for JobCostCategory
 */
export function isJobCostCategory(value: unknown): value is JobCostCategory {
  throw new Error('NotYetImplementedError: job-costing/JC-014')
}

/**
 * Get display name for category
 */
export function getCategoryDisplayName(category: JobCostCategory): string {
  throw new Error('NotYetImplementedError: job-costing/JC-014')
}
